// Stellarium Web - Copyright (c) 2022 - Stellarium Labs SRL
//
// This program is licensed under the terms of the GNU AGPL v3, or
// alternatively under a commercial licence.
//
// The terms of the AGPL v3 license can be found in the main directory of this
// repository.

<template>
  <div class="bottom-button" :class="{on: toggled}">
    <a v-on:click='clicked'>
      <img :src="img" :alt="img_alt"/>
    </a>
    <!-- [guanxing patch] 标签常显（图标+中文短标签），取代上游的 hover hint。 -->
    <div class="label">{{label}}</div>
  </div>
</template>

<style>
  /* [guanxing patch] M-SW46：宽度由固定 42px 改为 min-width 自适应——标签
     （如「把这片星空带走」6 字 ≈60px）长于 42px 时原样溢出容器，与相邻按钮
     的标签重叠；现在按钮被标签撑宽，图标（固定 42px 锚）居中，flex 布局
     自然推开相邻按钮，不再重叠。 */
  .bottom-button {
    min-width: 42px;
    position: relative;
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    user-select: none;
    cursor: pointer;
  }
  .bottom-button a {
    width: 42px;
    height: 42px;
    display: block;
  }
  .bottom-button img {
    width: 100%;
    height: 100%;
    filter: opacity(0.5);
  }
  .bottom-button.on img {
    filter: opacity(1);
  }
  .bottom-button .label {
    font-size: 10px;
    line-height: 12px;
    color: rgba(255, 255, 255, 0.75);
    white-space: nowrap;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.8);
  }
  .bottom-button.on .label {
    color: white;
  }
  /* [guanxing patch] 小屏保留文字（M-SW31 移动端文字恢复，修订 M-SW3b 的
     「小屏隐藏文字」降级）：上游的 label 靠 :hover 显示，触屏无 hover；
     M-SW3b 改为常显后若小屏仍 display:none，图标与文字双双缺席，
     用户看不出按钮含义。故小屏只降字号（10px → 9px）不隐藏——中文标签
     最长 4 字（如「二十八宿」）≈36px，仍在按钮 42px 宽度内，底栏不溢出。
     M-SW33：条件放宽为「短边≤600 且触屏」，手机横屏（宽>600px）同样生效，
     字面量须与 assets/phone-media.js 同步。 */
  @media all and (max-width: 600px), (pointer: coarse) and (max-height: 600px) and (max-width: 1100px) {
    .bottom-button .label {
      font-size: 9px;
      line-height: 11px;
    }
  }
</style>

<script>
export default {
  name: 'bottom-button',
  props: ['label', 'img', 'toggled', 'img_alt'],
  methods: {
    clicked: function () {
      var b = !this.toggled
      this.$emit('clicked', b)
    }
  }
}
</script>
